<template>
  <div class="study-overview" v-if="rolePower">
    <StudyInfo :overviewInfo="overviewInfo" :stateProgress="stateProgress" @openMap="openMap" @openStudyPopup="openStudyPopup"></StudyInfo>
    <StudyMap :initData="journeyInfo"></StudyMap>
    <SwitchMapPopup :show="showLearningPath" :showTips="showLearningPathTips" :journeyList="journeyList" :selectedMapId="overviewInfo && overviewInfo.id" @switchMap="switchMap" @closePopup="closeMapPopup"></SwitchMapPopup>
    <go-StudyPopup :isShowPopup="showStudyPopup" :initData="journeyInfo" @closePopup="closeStudyPopup"></go-StudyPopup>
  </div>
</template>

<script>
import { getStudyOverview, getStudyMap } from '../api/api'
import { Toast } from 'vant'
import StudyInfo from '@/views/home/components/StudyInfo.vue'
import SwitchMapPopup from '@/views/home/components/SwitchMapPopup.vue'
import goStudyPopup from '@/views/home/components/goStudyPopup.vue'
import StudyMap from '@/views/home/components/StudyMap.vue'
import { BOOL_GOAL, BOOL_NON_GOAL, BOOL_NON_EP, BOOL_SENIOR_EMPLOYEE } from '@/utils/configRoles'
import { checkObject } from '@/utils/util'
export default {
  name: 'StudyOverview',
  components: {
    StudyInfo,
    SwitchMapPopup,
    goStudyPopup,
    StudyMap
  },
  data() {
    return {
      overviewInfo: {},
      showLearningPath: false,
      showLearningPathTips: false,
      showRTC: false,
      journeyList: [],
      stateProgress: 0,
      showStudyPopup: false,
      journeyInfo: {},
      currentMapInfo: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    // 是否为目标EP术者、非目标EP术者、none-ep 或者 大主任兼学员
    rolePower() {
      return BOOL_GOAL || BOOL_NON_GOAL || BOOL_NON_EP || BOOL_SENIOR_EMPLOYEE
    },
    travelMapInfo() {
      return this.$store.getters.travelMapInfo
    }
  },
  methods: {
    async getInfo() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      let params = {
        multiCode: this.userInfo.multiCode
      }
      await getStudyOverview(params)
        .then(res => {
          Toast.clear()
          console.log('🚀 ~ file: StudyOverview.vue:77 ~ getStudyOverview ~ res:', res)
          if (res && res.data) {
            this.currentMapInfo = JSON.parse(JSON.stringify(res.data))
            let arr = JSON.parse(JSON.stringify(res.data))
            let arr2 = arr.filter(item => {
              return item.state === '1' // 返回已解锁地图
            })
            if (checkObject(this.travelMapInfo)) {
              this.overviewInfo = this.travelMapInfo
            } else {
              this.overviewInfo = arr2[arr2.length - 1] // 默认选中已解锁的最后一张地图
            }
            this.overviewInfo.id = this.overviewInfo.id.toString()
            console.log('🚀 ~ file: StudyOverview.vue:80 ~ getStudyOverview ~ overviewInfo:', this.overviewInfo)
            this.journeyList = JSON.parse(JSON.stringify(res.data))
            if (this.journeyList.length > 0) {
              let arr = this.journeyList.filter(item => {
                return item.state === '2' // 返回未解锁的地图数据
              })
              if (arr.length > 0) {
                this.showLearningPathTips = true // 有未解锁地图显示提示
              }
            }
          }
        })
        .catch(err => {
          console.log('🚀 ~ file: StudyOverview.vue:93 ~ getInfo ~ err:', err)
          Toast.clear()
        })
    },
    async getMapInfo() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      await getStudyMap({
        journeyId: this.overviewInfo.id,
        userId: this.userInfo.id
      })
        .then(res => {
          Toast.clear()
          if (res && res.data) {
            console.log('getMapInfo res.data', res.data)
            this.journeyInfo = res.data
            // 统计阶段完成进度
            let array = res.data.stages
            for (let index = 0; index < array.length; index++) {
              const element = array[index]
              if (element.learningRatePercent) {
                this.stateProgress += Number(element.learningRatePercent.replace(/[^\d.]/g, ''))
              }
            }
            if (this.stateProgress > 0) {
              this.stateProgress = Number(this.stateProgress / array.length)
            }
            console.log('stateProgress', this.stateProgress)
          }
        })
        .catch(err => {
          Toast.clear()
          if (err) {
            Toast(err.msg || '请求失败')
          }
        })
    },
    openMap() {
      console.log(`click closeMapPopup`)
      this.showLearningPath = true
      if (this.journeyList.length === 1) {
        Toast('其他地图正在开发中，敬请期待!')
        return false
      }
      this.getInfo()
    },
    openStudyPopup() {
      this.showStudyPopup = true
    },
    switchMap(id) {
      console.log('switchMap')
      let currentInfo = JSON.parse(JSON.stringify(this.currentMapInfo))
      this.overviewInfo = currentInfo.find(item => {
        return item.id === id
      })
      this.$store.commit('SET_TRAVEL_MAP_INFO', this.overviewInfo)
      this.overviewInfo.id = this.overviewInfo.id.toString()
      this.getMapInfo()
      this.showLearningPath = false
    },
    closeMapPopup() {
      this.showLearningPath = false
    },
    closeStudyPopup() {
      this.showStudyPopup = false
    }
  },
  async mounted() {
    if (this.rolePower) {
      await this.getInfo()
      await this.getMapInfo()
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/StudyOverview.vue